import { TableBodyCell } from "@components/table/table";
import { classNames } from "@helpers/css";

const PerformanceAssessmentTableEmptyCell = ({
  padLeft,
}: {
  padLeft: boolean;
}) => {
  return (
    <TableBodyCell>
      <div className={classNames("min-w-12 text-gray-300", padLeft && "pl-6")}>
        N/A
      </div>
    </TableBodyCell>
  );
};

export default PerformanceAssessmentTableEmptyCell;
